<template>
    <div>
        <header class="">
            <div class="w">
                <div class="center">
                    <div class="left" style="cursor:pointer;" @click="logoClick">
                        <div>
                            <van-image width="36px" height="36px" radius="4px" :src="logoUrl" />
                        </div>
                        <div class="name">玖月琴侣</div>
                    </div>
                    <div class="right">
                        <div class="style" :style="tabIndex == 1 ? tabIndexStyle2 : tabIndexStyle"
                            @click="scrollClick(1)">
                            产品介绍</div>
                        <div class="style" :style="tabIndex == 2 ? tabIndexStyle2 : tabIndexStyle"
                            @click="scrollClick(2)">
                            品牌荣誉</div>
                        <div class="style" :style="tabIndex == 3 ? tabIndexStyle2 : tabIndexStyle"
                            @click="scrollClick(3)">
                            用户评价</div>
                        <div class="style" :style="tabIndex == 4 ? tabIndexStyle2 : tabIndexStyle"
                            @click="scrollClick(4)">
                            合作加盟</div>
                    </div>
                </div>
            </div>
        </header>
        <main ref="main" @scroll="orderScroll">
            <div class="banner">
                <div class="w">
                    <div class="w_banner">
                        <!-- <van-image width="100%" radius="4px"
                            src="http://banner.joymido.com/32d395e15d9e8d49cc6ecca9bcd0781e" /> -->
                        <img src="../assets/homebanner_img.png" alt="" style="width: 100vw;">
                        <div class="banner_contant">
                            <!-- <div class="banner_contant_tips">
                                <div class="banner_contant_tips_left">
                                    <div class="banner_contant_tips_left_name">郑重声明：</div>
                                    <div class="tips">
                                        <p>我司产品正规售卖渠道仅为玖月琴侣HD总部及授权经销机构，凡非法售卖侵害我司社会信誉和经济利益的企业或个人，我司保留依法法追偿相应损失的权利。</p>
                                    </div>
                                </div>
                                <div class="banner_contant_tips_right">
                                    <van-icon class="icon" style="margin-top:10px;cursor:pointer;" @click="DeclarationLetterFlag = true" size="56px" :name="moreIcon" />
                                </div>
                            </div> -->
                            <div class="banner_title">
                                玖月琴侣课后陪练服务
                            </div>
                            <div class="banner_explain">
                                电子键盘教师力推的智能陪练
                            </div>
                            <div class="iconExhibition">
                                <van-image width="460px" radius="4px" :src="iconExhibitionUrl" />
                            </div>
                            <div class="ScanCode" @mouseenter="enter()" @mouseleave="leave()">
                                <van-icon class="icon" size="24px" :name="downloadIcon" />
                                <div class="downloadName">扫码下载</div>
                            </div>
                            <div class="codeImg" v-show="codeImgFlag">
                                <van-image width="100%" radius="4px" :src="codeImg" />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="banner_bottom">

                </div>
            </div>
            <!-- 轮播 -->
            <div style="background:#fff;margin:48px 0;">
                <div class="w">
                    <div class="Why">
                        <div class="title_name">
                            <div class="title">为什么选择</div>
                            <div class="name">玖月琴侣课后陪练服务？</div>
                        </div>
                        <div class="explain">丰富科学的陪练产品和功能让学琴变得更快乐</div>
                        <div class="swipe">
                            <!-- <van-swipe indicator-color="#FED847" initial-swipe="1" :autoplay="3000">
                            <van-swipe-item v-for="(item, index) in images" :key="index">
                                <img style="width:100%;border-radius:4px;" v-lazy="item.url" />
                                <div class="swipeName">
                                    <div class="one">{{item.name}}</div>
                                    <div class="two">{{item.title}}</div>
                                </div>
                            </van-swipe-item>
                        </van-swipe> -->
                            <el-carousel height="678px" arrow="always">
                                <el-carousel-item v-for="(item, index) in images" :key="index">
                                    <img style="width:100%;border-radius:4px;" v-lazy="item.url" />
                                    <div class="swipeName">
                                        <div class="one">{{ item.name }}</div>
                                        <div class="two">{{ item.title }}</div>
                                    </div>
                                </el-carousel-item>
                            </el-carousel>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 课后练习过程 -->
            <div class="afterClass">
                <div class="w">
                    <div class="title_name">
                        <div class="title">课后练习</div>
                        <div class="name">过程不再困难</div>
                    </div>
                    <div class="explain">AI智能陪练系统帮助孩子高效练琴提升自信</div>
                    <div class="tab">
                        <div class="tab_btn">
                            <div class="li" :style="processClickNum == index ? SelectStyle : UncheckedStyle"
                                v-for="(item, index) in processData" :key="index"
                                @mouseenter="processClick(item, index)">
                                <div class="one">
                                    <van-icon class="icon" size="36px"
                                        :name="processClickNum == index ? item.icon_onclick : item.icon_onblur" />
                                    <div style="margin-left:8px;"
                                        :style="processClickNum == index ? 'color:#000000' : 'color: rgba(0, 0, 0, 0.38)'">
                                        {{ item.title }}</div>
                                </div>
                                <div class="two"
                                    :style="processClickNum == index ? 'color:#000000' : 'color: rgba(0, 0, 0, 0.38)'">
                                    {{ item.note }}</div>
                            </div>
                        </div>
                        <div class="tab_img">
                            <van-image width="100%" radius="4px" :src="processImg" />
                        </div>
                    </div>
                </div>
            </div>
            <!-- 课后练习结果 -->
            <div class="afterClass" style="background:#fff;">
                <div class="w">
                    <div class="title_name">
                        <div class="title">课后练习</div>
                        <div class="name">结果高效清晰</div>
                    </div>
                    <div class="explain">寓教于乐数据驱动让孩子每次练习都有结果</div>
                    <div class="tab">
                        <div class="tab_img">
                            <van-image width="100%" radius="4px" :src="resultImg" />
                        </div>
                        <div class="tab_btn">
                            <div class="li" :style="resultClickNum == index ? SelectStyle : UncheckedStyle2"
                                v-for="(item, index) in resultData" :key="index" @mouseenter="resultClick(item, index)">
                                <div class="one">
                                    <van-icon class="icon" size="36px"
                                        :name="resultClickNum == index ? item.icon_onclick : item.icon_onblur" />
                                    <div style="margin-left:8px;"
                                        :style="resultClickNum == index ? 'color:#000000' : 'color: rgba(0, 0, 0, 0.38)'">
                                        {{ item.title }}</div>
                                </div>
                                <div class="two"
                                    :style="resultClickNum == index ? 'color:#000000' : 'color: rgba(0, 0, 0, 0.38)'">
                                    {{ item.note }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 启蒙十级 -->
            <div>
                <div class="horseRaceLamp">
                    <div class="name">从启蒙到十级</div>
                    <div class="explain">提供超400本、20000首智能化曲谱</div>
                    <div class="run">
                        <section class="picTab">
                            <ul class="ul1">
                                <li v-for="(item, index) in imgData">
                                    <van-image width="100%" height="100%" radius="4px;" :src="item" />
                                </li>
                            </ul>
                        </section>
                        <section class="picTab">
                            <ul class="ul2">
                                <li v-for="(item, index) in imgData2">
                                    <van-image width="100%" height="100%" radius="4px;" :src="item" />
                                </li>
                            </ul>
                        </section>
                        <section class="picTab">
                            <ul class="ul3">
                                <li v-for="(item, index) in imgData3">
                                    <van-image width="100%" height="100%" radius="4px;" :src="item" />
                                </li>
                            </ul>
                        </section>
                    </div>
                </div>
            </div>
            <!-- 教学研发 -->
            <!-- <div class="study">
                <div class="w">
                    <div class="name">专为教学研发</div>
                    <div class="explain">汇总数千位钢琴教师建议的智能教学工具</div>
                    <div class="CloudCoaching">
                        <div class="CloudCoaching_left" style="margin-left:50%;">
                            <div class="fontWight">云辅导</div>
                            <div class="fontColor">把老师带回家，课后作业由教师布置并在线辅导，课堂课后高效无缝衔接</div>
                            <div class="Tips">Tips:此功能需向机构或教师申请通过后方能使用。</div>
                        </div>
                    </div>
                    <van-image
                        width="100%"
                        radius="4px"
                        style="margin-top:24px;"
                        src="http://banner.joymido.com/f6786dc2f8f0bd122cd65771b70d4e8d"
                    />
                    <div class="CloudCoaching">
                        <div class="CloudCoaching_left" style="width:600px;">
                            <div class="fontWight">云课堂</div>
                            <div class="fontColor">把教室带回家，100%还原线下授课场景，全方位解决无法线下授课的问题。</div>
                            <div class="Tips">Tips:此功能需向机构或教师申请通过后方能使用。</div>
                        </div>
                    </div>
                    <van-image
                        width="100%"
                        radius="4px"
                        style="margin-top:24px;"
                        src="http://banner.joymido.com/002c7b59beb1fe968952f98c01c8104a"
                    />
                </div>
            </div> -->
            <!-- 品牌荣誉 -->
            <div class="honor">
                <div class="w">
                    <div class="titleStyle">品牌荣誉</div>
                    <div class="titleborder"></div>
                    <div class="honor_w">
                        <div class="iconLeft" @mouseenter="iconLeftEnter()" @mouseleave="iconLeftLeave()">
                            <van-image width="100%" height="100%"
                                :src="leftIconFalg == false ? leftIcon : leftIconFocus" @click="leftIconClick"
                                style="cursor:pointer;" />
                        </div>
                        <div class="iconRight" @mouseenter="iconRightEnter()" @mouseleave="iconRightLeave()">
                            <van-image width="100%" height="100%"
                                :src="rightIconFlag == false ? rightIcon : rightIconFocus" @click="rightIconClick"
                                style="cursor:pointer;" />
                        </div>
                        <div class="honorCenter" ref="honorCenter">
                            <div class="li" v-for="(item, index) in honorData" :key="index">
                                <van-image width="100%" height="247px" :src="item.url" />
                                <div class="title">{{ item.title }}</div>
                                <p class="contentWord">{{ item.note }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 用户评价 -->
            <div class="evaluate">
                <div class="w">
                    <div class="titleStyle">用户评价</div>
                    <div class="titleborder"></div>
                    <van-row gutter="24" style="margin-top:128px;">
                        <van-col style="margin-top:24px;" span="6" v-for="(item, index) in UserEvaluationData"
                            :key="index">
                            <van-image @click="imgClick(index)" width="100%" radius="4px" class="van_image"
                                style="box-shadow: 0px 8px 16px rgba(12, 0, 51, 0.1);" :src="item" />
                        </van-col>
                    </van-row>
                </div>
            </div>

            <!-- 合作加盟 -->
            <div class="JoinIn">
                <div class="titleStyle">合作加盟</div>
                <div class="titleborder"></div>
                <div class="agent">玖月琴侣全国代理商&合作机构火热招商中</div>
                <div class="w numberList">
                    <div class="number">
                        <div class="num">
                            <div class="left">30</div>
                            <div class="right">+</div>
                        </div>
                        <div class="explain">覆盖全国省份</div>
                    </div>
                    <div class="number">
                        <div class="num">
                            <div class="left">200</div>
                            <div class="right">+</div>
                        </div>
                        <div class="explain">覆盖城市</div>
                    </div>
                    <div class="number">
                        <div class="num">
                            <div class="left">900</div>
                            <div class="right">+</div>
                        </div>
                        <div class="explain">授权合作机构</div>
                    </div>

                </div>

                <div class="source">数据来源：玖月琴侣后台大数据统计 （数据截止2025年7月28日）</div>
                <div class="cooperation" @click="cooperationClick">我要合作</div>
            </div>

            <div class="footer">
                <!-- <div class="one">Copyright © 2013-2021 大连佳音科技有限公司版权所有（京ICP备2025137204号）</div> -->
                <div class="two">
                    <van-icon size="12" :name="policeBadgeIcon" />
                    <div>京ICP备2025137204号</div>
                </div>
            </div>
        </main>
        <!-- <el-dialog
            title=""
            :visible.sync="DeclarationLetterFlag"
            width="45%"
            :show-close="false"
            >
            <div class="DeclarationLetter">
                <div class="DeclarationLetter_title">玖月琴侣官方声明函</div>
                <div class="DeclarationLetter_contant"></br></br></br>大连佳音科技有限公司是“玖月琴侣HD”的研发生产方，是其知识产权、软件著作权、商标及专利权的所有者。近日，我司在闲鱼等APP平台发现不法商家及个人未经我司授权，批量发布和违规售卖未经我司认证授权的设备，并在其宣传过程中滥用我司品牌标识及广告语，涉嫌误导消费者的虚假销售行为，扰乱我司产品的市场定位和销售规定，上述行为已经损害了我司的社会信誉与经济利益，构成对我司合法权利的侵犯。
                    </br></br>对此，我司郑重声明如下</br></br>
                    一、玖月琴侣HD仅在售“玖月琴侣课后陪练服务”和“玖月琴侣智能曲谱服务”两款产品。</br></br>
                    二、玖月琴侣HD提供的相关产品仅可从如下渠道购买：</br>
                    1.玖月琴侣HD官方总部；</br>
                    2.玖月琴侣HD官方授权的地方代理商、合作机构。</br></br>
                    三、纠错大师（JOY MASTER)仅为“玖月琴侣课后陪练服务”配备的辅助设备，不作单独售卖。从非法渠道单独购买此设备，我司不提供一切售后服务和用户权益。</br></br>
                    正式警告涉及侵犯我司合法权利的商家和个人，立刻下架违规产品，停止销售行为。对于仍然非法销售的商家及个人，一切后果，自行承担，并且我司保留采取司法措施权利，以及追偿由此引发的任何损害赔偿及相关费用的权利。
                    </br></br>特此声明！
                </div>
                <div class="DeclarationLetter_bottom">大连佳音科技有限公司</div>
                <div class="know" style="cursor:pointer;" @click="DeclarationLetterFlag = false">我知道了</div>
            </div>
        </el-dialog> -->
        <van-popup v-model="cooperationFlag">
            <div class="cooperation">
                <div class="cooperation_top">
                    玖月琴侣合作加盟申请表
                    <van-icon class="closeIcon" @click="closeClick" size="48" :name="closeIcon" />
                </div>
                <div class="title">欢迎加入玖月琴侣</div>
                <div class="tips">为更好的了解您的需求，方便及时有效的沟通，请填写如下表单。</div>
                <div class="el_form">
                    <el-form :inline="false" label-width="128px" :model="cooperationForm" class="demo-form-inline">
                        <el-form-item label="公司（机构）名称">
                            <el-input width="500px" v-model="cooperationForm.orgName"
                                placeholder="请输入您的公司（机构）名称"></el-input>
                        </el-form-item>
                        <el-form-item label="姓名">
                            <el-input width="500px" v-model="cooperationForm.name" placeholder="请输入您的姓名"></el-input>
                        </el-form-item>
                        <el-form-item label="手机">
                            <el-input width="500px" v-model="cooperationForm.phone" placeholder="请输入您的手机号"></el-input>
                        </el-form-item>
                        <el-form-item label="城市">
                            <el-input width="500px" v-model="cooperationForm.city" placeholder="请输入您所在的城市"></el-input>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="submitBtn" @click="submitBtnClick">
                    提交信息
                </div>
            </div>
        </van-popup>
        <div class="navigationButton">
            <!-- <div class="li" @mouseenter="customerServiceEnter()" @mouseleave="customerServiceLeave()">
                <van-icon size="32" style="margin-top:9px;" :name="customerServiceFlag == true?customerService2:customerService" />
                <div class="li_name">在线客服</div>
            </div> -->
            <div style="width:100%;height:72px;">

            </div>
            <div class="li" @mouseenter="ScanCodeEnter()" @mouseleave="ScanCodeLeave()">
                <van-icon size="32" style="margin-top:9px;"
                    :name="ScanCodeEnterFlag == true ? ScanCodeIcon2 : ScanCodeIcon" />
                <div class="li_name">扫码关注</div>
            </div>
            <div class="li" @mouseenter="contactEnter()" @mouseleave="contactLeave()">
                <van-icon size="32" style="margin-top:9px;" :name="contactEnterFlag == true ? contact2 : contact" />
                <div class="li_name">联系方式</div>
            </div>
            <div class="li" v-show="BackToTopFlag" @click="BackToTopClick">
                <div @mouseenter="BackToTopEnter()" @mouseleave="BackToTopLeave()">
                    <van-icon size="32" style="margin-top:9px;"
                        :name="BackToTopBtnFlag == true ? BackToTop2 : BackToTop" />
                    <div class="li_name">返回顶部</div>
                </div>
            </div>
        </div>
        <div class="ScanCodeStyle" v-show="ScanCodeEnterFlag == true">
            <van-image width="50%" height="100%" radius="4px" :src="QrCode" />
        </div>
        <div class="information" v-show="contactEnterFlag">
            <div class="li">
                <div class="left">
                    <van-image width="20px" height="18px" style="margin-top:2px;" :src='cooperationIcon' />
                </div>
                <div class="right">
                    <div class="title">商务合作：</div>
                    <div class="name"><span>jiuyueqinlv@163.com</span></div>
                </div>
            </div>
            <div class="li">
                <div class="left">
                    <van-image width="20px" height="18px" style="margin-top:2px;" :src='addressIcon' />
                </div>
                <div class="right">
                    <div class="title">公司地址：</div>
                    <div class="name">北京市朝阳区高碑店乡西店记忆F3-F108玖月音乐</div>
                </div>
            </div>
            <div class="li">
                <div class="left">
                    <van-image width="20px" height="18px" style="margin-top:2px;" :src='phoneIcon' />
                </div>
                <div class="right">
                    <div class="title">全国24小时统一热线：</div>
                    <div class="name">19264192748</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
import { NoticeBar, Image as VanImage, Col, Row, Popup, Toast, Notify } from 'vant';
Vue.use(NoticeBar);
Vue.use(Col);
Vue.use(Row);
Vue.use(Popup);
Vue.use(Toast);
Vue.use(Notify);
export default {
    name: 'PC',
    conponents: {
        VanImage,
        NoticeBar
    },
    data() {
        return {
            tabIndex: 1,
            DeclarationLetterFlag: false,
            cooperationFlag: false,
            moreIcon: require('../assets/web_mobile_more.png'),
            iconExhibitionUrl: require('../assets/web_mobile_top_app.png'),
            downloadIcon: require('../assets/web_mobile_top_icon.png'),
            codeImg: require('../assets/web_mobile_code03.png'),
            leftIcon: require('../assets/arrows03.png'),
            leftIconFocus: require('../assets/arrows04.png'),
            rightIcon: require('../assets/arrows01.png'),
            rightIconFocus: require('../assets/arrows02.png'),
            logoUrl: require('../assets/logo_img.png'),
            customerService: require('../assets/web_mobile_sidebar_icon01_nor.png'),
            customerService2: require('../assets/web_mobile_sidebar_icon01_sel.png'),
            ScanCodeIcon: require('../assets/web_mobile_sidebar_icon02_nor.png'),
            ScanCodeIcon2: require('../assets/web_mobile_sidebar_icon02_sel.png'),
            contact: require('../assets/web_mobile_sidebar_icon03_nor.png'),
            contact2: require('../assets/web_mobile_sidebar_icon03_sel.png'),
            BackToTop: require('../assets/web_mobile_sidebar_icon04_nor.png'),
            BackToTop2: require('../assets/web_mobile_sidebar_icon04_sel.png'),
            QrCode: 'http://banner.joymido.com/581f3fdfcb94d87e1262d1dba856aa62',
            miniImg: 'http://banner.joymido.com/ea3b9f4485f0045d94adc4a50ae4dd90',
            cooperationIcon: require('../assets/web_mobile_us_icon03.png'),
            addressIcon: require('../assets/web_mobile_us_icon02.png'),
            phoneIcon: require('../assets/web_mobile_us_icon01.png'),
            policeBadgeIcon: require('../assets/policeBadge.png'),
            closeIcon: require('../assets/web_mobile_close.png'),
            imgWidth: '',
            images: [
                { url: 'http://banner.joymido.com/web_mobile_banner01.png', name: "孩子更快乐的练琴", title: "多样的激励功能让每一次弹奏都有收获感" },
                { url: 'http://banner.joymido.com/web_mobile_banner02.png', name: "家长更快乐的陪伴", title: "清晰的陪练功能让陪练变得既开心又融洽" },
                { url: 'http://banner.joymido.com/web_mobile_banner03.png', name: "教师更快乐的授课", title: "高效的练习成果让教师回课效率大大提高" },
            ],

            // 从启蒙到十级数据
            imgData: [],
            imgData2: [],
            imgData3: [],
            processData: [],
            processClickNum: '',
            processImg: '',

            resultClickNum: '',
            resultData: [],
            resultImg: '',
            SelectStyle: 'background: #FED847',
            tabIndexStyle: 'background: #fff',
            tabIndexStyle2: 'background: #FED847;color:#000',
            UncheckedStyle: 'background: #f4f4f4',
            UncheckedStyle2: 'background: #fff',
            UserEvaluationData: [],
            codeImgFlag: false,
            // 荣誉数组
            honorData: [
                {
                    url: "http://banner.joymido.com/0f346bba5a879ebea48c561ff5bacb85",
                    title: '『荣获国家高新技术企业荣誉』',
                },
                {
                    url: "http://banner.joymido.com/1aeb2f1f4b4b6ef5d5f90b7315377326",
                    title: '『多项产品发明专利及软件著作权』',
                },
            ],
            honorIndex: 0,
            leftIconFalg: false,
            rightIconFlag: false,
            ScanCodeEnterFlag: false,
            customerServiceFlag: false,
            contactEnterFlag: false,
            BackToTopFlag: false,
            BackToTopBtnFlag: false,
            scrollClickFlag: true,
            cooperationForm: {
                "orgName": "",
                "phone": "",
                "name": "",
                "province": "",
                "city": ""
            }
        }
    },
    mounted() {
        this.pmd()
        this.website_mobile_tab_img()
        this.website_mobile_tab_img_result()
        this.website_pj()
        // this.website_rongyu()
    },
    methods: {
        logoClick() {
            window.location.reload()
        },
        website_rongyu() {
            this.$http.get('/website/type/website_rongyu').then(res => {
                let data = []
                for (let i = 0; i < res.data.data.length; i++) {
                    let JSONData = JSON.parse(res.data.data[i].description)
                    data.push(JSONData)
                }
                this.honorData = data
            })
        },
        submitBtnClick() {
            let reg_tel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
            if (this.cooperationForm.orgName == '') {
                Notify({ type: 'danger', message: '请填写您的公司（机构）名称' });
            } else if (this.cooperationForm.name == '') {
                Notify({ type: 'danger', message: '请填写您的姓名' });
            } else if (this.cooperationForm.phone == '') {
                Notify({ type: 'danger', message: '请填写您的手机号' });
            } else if (this.cooperationForm.city == '') {
                Notify({ type: 'danger', message: '请填写您所在的城市' });
            } else if (!reg_tel.test(this.cooperationForm.phone)) {
                Notify({ type: 'danger', message: '请填写正确的手机号' });
            } else {
                this.$http.post('/organ/addOrganWebsiteApply', {
                    "orgName": this.cooperationForm.orgName,
                    "phone": this.cooperationForm.phone,
                    "name": this.cooperationForm.name,
                    "city": this.cooperationForm.city
                }).then(res => {
                    if (res.data.code == 1) {
                        Notify({ type: 'danger', message: res.data.msg });
                    } else {
                        this.cooperationFlag = false
                        this.cooperationForm = {
                            "orgName": "",
                            "phone": "",
                            "name": "",
                            "province": "",
                            "city": ""
                        }
                        Toast.success("提交成功");
                    }
                })
            }
        },
        cooperationClick() {
            this.cooperationFlag = true
        },
        closeClick() {
            this.cooperationFlag = false
        },
        orderScroll() {
            if (this.$refs.main.scrollTop > 1200) {
                this.BackToTopFlag = true
            } else {
                this.BackToTopFlag = false
            }
            if (this.scrollClickFlag == true) {
                if (7800 > this.$refs.main.scrollTop && this.$refs.main.scrollTop > 7500) {
                    this.tabIndex = 2
                } else if (8700 > this.$refs.main.scrollTop && this.$refs.main.scrollTop > 8400) {
                    this.tabIndex = 3
                } else if (9500 > this.$refs.main.scrollTop && this.$refs.main.scrollTop > 9200) {
                    this.tabIndex = 4
                } else if (this.$refs.main.scrollTop < 1200) {
                    this.tabIndex = 1
                }
            }
        },
        BackToTopClick() {
            let scrollTop = this.$refs.main.scrollTop
            var timer = setInterval(() => {
                if (scrollTop > 0) {
                    scrollTop = scrollTop - 100
                    this.$refs.main.scrollTop = scrollTop
                } else {
                    clearInterval(timer)
                }
            }, 1);
        },
        pmd() {
            let imgData = []
            let concatArr = []
            let imgData2 = []
            let concatArr2 = []
            let imgData3 = []
            let concatArr3 = []
            for (var i = 0; i < 40; i++) {
                let url = 'https://cover.img.joymido.com/M_' + Math.ceil(Math.random() * 95) + '.jpg'
                let url2 = 'https://cover.img.joymido.com/M_' + Math.ceil(Math.random() * 95) + '.jpg'
                let url3 = 'https://cover.img.joymido.com/M_' + Math.ceil(Math.random() * 95) + '.jpg'
                imgData.push(url)
                concatArr.push(url)
                imgData2.push(url2)
                concatArr2.push(url2)
                imgData3.push(url3)
                concatArr3.push(url3)
            }
            this.imgData = imgData.concat(concatArr)
            this.imgData2 = imgData2.concat(concatArr2)
            this.imgData3 = imgData3.concat(concatArr3)
        },
        BackToTopEnter() {
            this.BackToTopBtnFlag = true
        },
        BackToTopLeave() {
            this.BackToTopBtnFlag = false
        },
        ScanCodeEnter() {
            this.ScanCodeEnterFlag = true
        },
        ScanCodeLeave() {
            this.ScanCodeEnterFlag = false
        },
        customerServiceEnter() {
            this.customerServiceFlag = true
        },
        customerServiceLeave() {
            this.customerServiceFlag = false
        },
        contactEnter() {
            this.contactEnterFlag = true
        },
        contactLeave() {
            this.contactEnterFlag = false
        },
        leftIconClick() {
            if (this.honorIndex > 0) {
                this.honorIndex = this.honorIndex - 1
                let scrollLeft = this.$refs.honorCenter.scrollLeft
                let scrollTo = this.honorIndex * 475
                var timer = setInterval(() => {
                    if (scrollLeft > scrollTo) {
                        scrollLeft = scrollLeft - 15
                        this.$refs.honorCenter.scrollLeft = scrollLeft
                    } else {
                        clearInterval(timer)
                    }
                }, 1);
            } else {
            }
        },
        rightIconClick() {
            // console.log(this.honorIndex)
            if (this.honorIndex < (this.honorData.length - 3)) {
                this.honorIndex = this.honorIndex + 1
                let scrollLeft = this.$refs.honorCenter.scrollLeft
                let scrollTo = this.honorIndex * 475
                var timer = setInterval(() => {
                    if (scrollLeft < scrollTo) {
                        scrollLeft = scrollLeft + 15
                        this.$refs.honorCenter.scrollLeft = scrollLeft
                    } else {
                        clearInterval(timer)
                    }
                }, 1);
            } else {
            }

        },
        enter() {
            this.codeImgFlag = true;
        },
        leave() {
            this.codeImgFlag = false;
        },
        iconLeftEnter() {
            this.leftIconFalg = true
        },
        iconLeftLeave() {
            this.leftIconFalg = false
        },
        iconRightEnter() {
            this.rightIconFlag = true
        },
        iconRightLeave() {
            this.rightIconFlag = false
        },
        website_pj() {
            this.$http.get('/website/type/website_pj').then(res => {
                let data = []
                for (let i = 0; i < res.data.data.length; i++) {
                    let JSONData = JSON.parse(res.data.data[i].description).url
                    data.push(JSONData)
                }
                this.UserEvaluationData = data
            })
        },
        resultClick(item, index) {
            this.resultClickNum = index
            this.resultImg = item.url
            this.resultName = item.note

        },
        processClick(item, index) {
            this.processClickNum = index
            this.processImg = item.url
            this.processName = item.note
        },
        website_mobile_tab_img_result() {
            this.$http.get('/website/type/website_mobile_tab_img_result').then(res => {
                let data = []
                for (let i = 0; i < res.data.data.length; i++) {
                    let JSONData = JSON.parse(res.data.data[i].description)
                    data.push(JSONData)
                }
                this.resultImg = data[0].url
                this.resultName = data[0].note
                this.resultData = data
            })
        },
        website_mobile_tab_img() {
            this.$http.get('/website/type/website_mobile_tab_img').then(res => {
                let data = []
                for (let i = 0; i < res.data.data.length; i++) {
                    let JSONData = JSON.parse(res.data.data[i].description)
                    data.push(JSONData)
                }
                this.processImg = data[0].url
                this.processName = data[0].note
                this.processData = data
            })
        },
        // getWidth(){
        //     this.imgWidth = (window.innerWidth/2) + 'px';
        //     console.log(this.width)
        // },
        scrollClick(index) {
            this.tabIndex = index
            this.scrollClickFlag = false
            if (index == 1) {
                let scrollTop = this.$refs.main.scrollTop
                var timer = setInterval(() => {
                    if (scrollTop > 0) {
                        scrollTop = scrollTop - 100
                        this.$refs.main.scrollTop = scrollTop
                    } else {
                        this.scrollClickFlag = true
                        clearInterval(timer)
                    }
                }, 1);
            } else if (index == 2) {
                let scrollTop = this.$refs.main.scrollTop
                if (scrollTop > 7500) {
                    var timer = setInterval(() => {
                        if (scrollTop > 7500) {
                            scrollTop = scrollTop - 100
                            this.$refs.main.scrollTop = scrollTop
                        } else {
                            this.scrollClickFlag = true
                            clearInterval(timer)
                        }
                    }, 1);
                } else if (scrollTop < 7500) {
                    var timer = setInterval(() => {
                        if (scrollTop < 7500) {
                            scrollTop = scrollTop + 100
                            this.$refs.main.scrollTop = scrollTop
                        } else {
                            this.scrollClickFlag = true
                            clearInterval(timer)
                        }
                    }, 1);
                } else {

                }
            } else if (index == 3) {
                let scrollTop = this.$refs.main.scrollTop
                if (scrollTop > 8400) {
                    var timer = setInterval(() => {
                        if (scrollTop > 8400) {
                            scrollTop = scrollTop - 100
                            this.$refs.main.scrollTop = scrollTop
                        } else {
                            this.scrollClickFlag = true
                            clearInterval(timer)
                        }
                    }, 1);
                } else if (scrollTop < 8400) {
                    var timer = setInterval(() => {
                        if (scrollTop < 8400) {
                            scrollTop = scrollTop + 100
                            this.$refs.main.scrollTop = scrollTop
                        } else {
                            this.scrollClickFlag = true
                            clearInterval(timer)
                        }
                    }, 1);
                } else {

                }
            } else if (index == 4) {
                let scrollTop = this.$refs.main.scrollTop
                let scrollHeight = this.$refs.main.scrollHeight
                var timer = setInterval(() => {
                    if (scrollTop < scrollHeight) {
                        scrollTop = scrollTop + 100
                        this.$refs.main.scrollTop = scrollTop
                    } else {
                        this.scrollClickFlag = true
                        clearInterval(timer)
                    }
                }, 1);
            }
            // this.$refs.main.scrollTo(0, 700)

        }
    },
    created() {
        window.addEventListener('resize', this.getWidth);
    },
    destroyed() {
        window.removeEventListener('resize', this.getWidth)
    }
}
</script>
<style lang="scss" scoped>
body {
    position: relative;
}

.w {
    width: 1400px;
    // margin: auto;
}

.el-carousel_item h3 {
    color: #FED847;
    font-size: 18px;
    opacity: 0.75;
    // line-height: 300px;
    margin: 0;

}

.el-dialog__body {
    padding: 0;
}

.el-carousel_item:nth-child(2n) {
    background-color: #FED847;
}

.el-carousel_item:nth-child(2n+1) {
    background-color: #FED847;
}

header {
    height: 82px;
    width: 100%;
    background: #fff;
    position: absolute;
    top: 0;
    left: 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);

    .center {
        width: 100%;
        height: 82px;
        display: flex;
        justify-content: space-between;

        .left {
            display: flex;
            align-items: center;

            .name {
                font-size: 24px;
                line-height: 32px;
                font-weight: 500;
                display: flex;
                color: #000000;
                margin-left: 8px;
            }
        }

        .right {
            display: flex;
            margin-top: 22px;

            .style:hover {
                color: #000000
            }

            .style {
                width: 112px;
                background: #fff;
                height: 38px;
                border-radius: 4px;
                color: rgba(0, 0, 0, 0.54);
                font-size: 16px;
                text-align: center;
                line-height: 38px;
                cursor: pointer;
            }
        }
    }
}

main::-webkit-scrollbar {
    display: none;
}

main {
    width: 100%;
    position: absolute;
    top: 83px;
    bottom: 0;
    overflow: auto;

    // left:0;
    .banner {
        width: 100%;
        // height: 680px;
        // background: url('http://banner.joymido.com/75640d4bca50ba922617399ead41e9cb');
        // background-size:100%;
        background-position: center;
        position: relative;

        .banner_bottom {
            width: 100%;
            position: absolute;
            z-index: 100;
            bottom: -50px;
            left: 0;
            height: 299px;
            background: url('http://banner.joymido.com/cf343dc3d541826f844915ba1aa3479a') no-repeat;
            // background-size:100%;
            background-position: center;
        }

        .codeImg {
            width: 282px;
            height: 282px;
            position: absolute;
            bottom: -290px;
            left: -15px;
            z-index: 1111;
        }

        .w_banner {
            position: relative;



            .banner_contant {
                width: 100%;
                position: absolute;
                top: 0;
                left: 0;
                padding-left: 30px;
                box-sizing: border-box;

                .banner_contant_tips {
                    width: 100%;
                    height: 56px;
                    background: rgba(255, 255, 255, 0.24);
                    border-radius: 4px;
                    margin-top: 24px;
                    display: flex;
                    align-items: center;

                    .banner_contant_tips_left {
                        width: 95%;
                        display: flex;
                        align-items: center;

                        .banner_contant_tips_left_name {
                            // width: 80px;
                            margin-left: 16px;
                            font-size: 14px;
                            color: rgba(0, 0, 0, 0.54);
                            font-weight: 600
                        }

                        .tips {
                            font-size: 14px;
                            color: rgba(0, 0, 0, 0.54);
                            overflow: hidden;

                            p {
                                // width: 9000px;
                                width: 100%;
                                overflow: hidden;
                                animation: 20s wordsLoop linear infinite;
                            }
                        }

                        @keyframes wordsLoop {
                            0% {
                                transform: translateX(0px);
                            }

                            100% {
                                transform: translateX(-100%);
                            }
                        }
                    }

                    .banner_contant_tips_right {
                        width: 5%;
                    }
                }

                .banner_title {
                    font-size: 56px;
                    line-height: 64px;
                    color: #fff;
                    margin-top: 48px;
                    font-weight: 600
                }

                .banner_explain {
                    font-size: 40px;
                    line-height: 47px;
                    color: #fff;
                    font-weight: 300;
                    margin-top: 12px;
                }

                .iconExhibition {
                    display: flex;
                    margin-top: 34px;
                }

                .ScanCode {
                    width: 224px;
                    height: 64px;
                    margin-top: 26px;
                    background: #FFFFFF;
                    border-radius: 4px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;

                    .downloadName {
                        font-size: 24px;
                        color: #000000;
                        margin-left: 11px;
                    }

                }

            }
        }
    }
}

.BackToTheTop {
    width: 24PX;
    height: 24PX;
    background: tan;
    position: fixed;
    bottom: 100px;
    right: 40px;
}

.Why {
    padding: 48px 0;

    .title_name {
        width: 100%;
        text-align: center;
        display: flex;
        justify-content: center;
    }

    .title {
        text-align: center;
        font-size: 56px;
        line-height: 56px;
        text-transform: capitalize;
        color: #000000;
        font-weight: 600;
    }

    .name {
        font-size: 56px;
        line-height: 56px;
        text-align: center;
        // display: inline-block;
        text-transform: capitalize;
        color: #1584FC;
        font-weight: 600;
        background-image: linear-gradient(90deg, #FF6543, #EE43BE, #1B5BFF, #0094FF, #32E2E2);
        box-sizing: border-box;
        // background-image: -webkit-linear-gradient(200.41deg, #32E2E2 0.84%, #0094FF  24.8%, #1B5BFF 51.37%, #EE43BE 74.81%, #FF6543 100.85%);
        // background: linear-gradient(to right, red, blue);
        -webkit-background-clip: text;
        color: transparent;
    }

    .explain {
        text-align: center;
        font-size: 24px;
        line-height: 24px;
        text-align: center;
        text-transform: capitalize;
        margin-top: 16px;
        color: rgba(0, 0, 0, 0.54);
        font-weight: 200;
    }

    .swipe {
        width: 100%;
        // height: 185px;
        // background: tan;
        margin: 0 auto;
        margin-top: 128px;
        border-radius: 4px;
        overflow: hidden;

        .swipeName {
            position: absolute;
            width: 100%;
            height: 128px;
            bottom: -4px;
            border-radius: 0 0 4px 4px;
            background: rgba(0, 0, 0, 0.54);

            .one {
                font-weight: 500;
                margin-top: 24px;
                font-size: 32px;
                line-height: 32px;
                text-align: center;
                text-transform: capitalize;
                color: #FFFFFF;
            }

            .two {
                font-size: 24px;
                margin-top: 12px;
                line-height: 24px;
                text-align: center;
                color: #FFFFFF;
                font-weight: 300
            }
        }
    }
}

.horseRaceLamp {
    width: 100%;
    padding: 128px 0;
    background: #f4f4f4;

    .name {
        width: 400px;
        margin: 0 auto;
        font-size: 56px;
        line-height: 56px;
        text-align: center;
        font-weight: 600;
        background-image: linear-gradient(90deg, #FF6543, #EE43BE, #1B5BFF, #0094FF, #32E2E2);
        box-sizing: border-box;
        -webkit-background-clip: text;
        color: transparent;
    }

    .explain {
        text-align: center;
        font-size: 24px;
        line-height: 24px;
        text-align: center;
        text-transform: capitalize;
        margin-top: 16px;
        color: rgba(0, 0, 0, 0.54);
        font-weight: 300;
    }

    .run {
        margin-top: 128px;

        @keyframes move {
            0% {
                transform: translateX(0px);
            }

            // 15% {transform:translateX(-200px); } 
            // 30% {transform:translateX(-400px); } 
            // 45% {transform:translateX(-600px); } 
            // 60% {transform:translateX(-800px); } 
            // 75% {transform:translateX(-1000px); } 
            // 90% {transform:translateX(-1200px); } 
            100% {
                transform: translateX(-6642px)
            }
        }

        // ul{margin:0;padding:0; list-style:none;} 
        .picTab {
            width: 100%;
            height: 204px;
            margin: 8px auto;
            overflow: hidden;
        }

        .picTab ul {
            width: 10000px;
            height: 204px;
        }

        .picTab li {
            float: left;
            width: 158px;
            height: 204px;
            margin: 0 4px;
            font: 50px/98px "宋体";
            text-align: center;
            border-radius: 4px;
            overflow: hidden;
            position: relative;
        }

        .ul1 {
            animation: move 95s linear infinite;
        }

        .ul2 {
            animation: move 80s linear infinite;
        }

        .ul3 {
            animation: move 95s linear infinite;
        }
    }

}

.afterClass {
    width: 100%;
    background: #f4f4f4;
    padding: 128px 0;

    .tab {
        justify-content: space-between;
        display: flex;
        margin-top: 128px;

        .tab_btn {
            width: 36%;

            .li {
                height: 204px;
                width: 100%;
                background: #FED847;
                border-radius: 4px;
                cursor: pointer;

                .one {
                    display: flex;
                    align-items: center;
                    font-size: 28px;
                    line-height: 30px;
                    padding-top: 48px;
                    margin-left: 48px;
                }

                .two {
                    padding: 0 48px;
                    margin-top: 12px;
                    font-size: 22px;
                    font-weight: 300
                }
            }
        }

        .tab_img {
            width: 63%;
        }
    }

    .title_name {
        width: 100%;
        text-align: center;
        display: flex;
        justify-content: center;
    }

    .title {
        text-align: center;
        font-size: 56px;
        line-height: 56px;
        text-transform: capitalize;
        color: #000000;
        font-weight: 600;
    }

    .name {
        font-size: 56px;
        line-height: 56px;
        text-align: center;
        // display: inline-block;
        text-transform: capitalize;
        color: #1584FC;
        font-weight: 600;
        background-image: linear-gradient(90deg, #FF6543, #EE43BE, #1B5BFF, #0094FF, #32E2E2);
        box-sizing: border-box;
        // background-image: -webkit-linear-gradient(200.41deg, #32E2E2 0.84%, #0094FF  24.8%, #1B5BFF 51.37%, #EE43BE 74.81%, #FF6543 100.85%);
        // background: linear-gradient(to right, red, blue);
        -webkit-background-clip: text;
        color: transparent;
    }

    .explain {
        text-align: center;
        font-size: 24px;
        line-height: 24px;
        text-align: center;
        text-transform: capitalize;
        margin-top: 16px;
        color: rgba(0, 0, 0, 0.54);
        font-weight: 300;
    }
}

.study {
    width: 100%;
    // height: 1050px;
    padding: 128px 0;
    padding-bottom: 0;
    background: url('../assets/background.png') no-repeat;
    background-size: 100%;
    background-position: bottom;

    // background: tan;
    .name {
        width: 400px;
        margin: 0 auto;
        font-size: 56px;
        line-height: 56px;
        text-align: center;
        text-transform: capitalize;
        color: #1584FC;
        font-weight: 600;
        background-image: linear-gradient(90deg, #FF6543, #EE43BE, #1B5BFF, #0094FF, #32E2E2);
        box-sizing: border-box;
        -webkit-background-clip: text;
        color: transparent;
    }

    .explain {
        text-align: center;
        font-size: 24px;
        line-height: 21px;
        text-align: center;
        text-transform: capitalize;
        margin-top: 16px;
        margin-bottom: 128px;
        font-weight: 300;
        color: rgba(0, 0, 0, 0.54);
    }

    .CloudCoaching {
        width: 100%;
        // margin:0 auto;
        height: 155px;
        margin-top: 48px;

        .CloudCoaching_right {
            height: 100%;
            border-right: 3px solid #FED847;
            padding-top: 2px;
            text-align: right;
            padding-right: 16px;
        }

        .CloudCoaching_left {
            height: 100%;
            margin-top: 48px;
            border-left: 3px solid #FED847;
            padding-top: 2px;
            padding-left: 16px;

            .Tips {
                font-size: 20px;
                line-height: 26px;
                color: rgba(0, 0, 0, 0.54);
                margin-top: 8px;
            }
        }
    }

}

.fontWight {
    font-size: 32px;
    line-height: 42px;
    color: #000000;
    font-weight: 600
}

.fontColor {
    font-size: 24px;
    line-height: 32px;
    color: #000000;
    margin-top: 8px;
    font-weight: 300
}

.titleStyle {
    font-size: 36px;
    line-height: 47px;
    color: #000000;
    text-align: center;
}

.titleborder {
    width: 128px;
    height: 8px;
    margin: 0 auto;
    background: #FED847;
    border-radius: 42px;
    margin-top: 16px;
}

.evaluate {
    padding: 128px 0;
    // background: #fff;
    width: 100%;

    .evaluate_img {
        width: 88%;
        margin: 0 auto;
        margin-top: 24px;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;

        .van_image {
            border: 1px solid rgba(0, 0, 0, 0.06);
            box-shadow: 0px 8px 16px rgba(12, 0, 51, 0.1);
        }
    }
}

.honor {
    width: 100%;
    background: #f4f4f4;
    padding: 128px 0;
    padding-bottom: 36px;
    // padding-bottom: 8px;
    overflow: hidden;

    // position: relative;
    .honorCenter::-webkit-scrollbar {
        display: none;
    }

    .honorCenter::-o-scrollbar {
        display: none;
    }

    .honorCenter::-moz-scrollbar {
        display: none;
    }

    .honorCenter::-Gecko-scrollbar {
        display: none;
    }

    .honor_w {
        position: relative;
    }

    .iconLeft {
        width: 56px;
        height: 56px;
        // background: tan;
        position: absolute;
        top: 45%;
        left: -150px;
        // z-index: 55;
    }

    .iconRight {
        width: 56px;
        height: 56px;
        // background: tan;
        position: absolute;
        top: 45%;
        right: -150px;
    }

    .honorCenter {
        width: 100%;
        height: 465px;
        padding-top: 128px;
        overflow-x: auto;
        overflow-y: hidden;
        white-space: nowrap;
        background: #f4f4f4;

        .li {
            width: 451px;
            height: 365px;
            background: #fff;
            display: inline-block;
            margin-right: 24px;
            border-radius: 4px;
            overflow: hidden;
            box-shadow: 0px 8px 16px rgba(12, 0, 51, 0.1);

            .title {
                width: 92%;
                margin: 0 auto;
                font-weight: bold;
                margin-top: 8px;
                font-size: 20px;
                line-height: 44px;
                text-align: center;
                text-transform: capitalize;
                color: #000000;
            }

            .contentWord {
                width: 70%;
                margin: 0 auto;
                white-space: pre-wrap;
                word-break: break-all;
                word-break: break-word;
                text-align: center;
                font-size: 17px;
                line-height: 24px;
                color: rgba(0, 0, 0, 0.54);
            }
        }
    }
}

.JoinIn {
    width: 100%;
    // height:720px ;
    padding: 48px 0;
    padding-bottom: 128px;
    background: url('http://banner.joymido.com/web_mobile_bj02.png') no-repeat;
    background-size: 100%;
    background-position: top;

    .agent {
        margin-top: 56px;
        font-size: 24px;
        line-height: 22px;
        text-align: center;
        text-transform: capitalize;
        color: rgba(0, 0, 0, 0.54);
        font-weight: 300;
    }

    .numberList {
        display: flex;
        margin-top: 128px;
    }

    .number {
        width: 74%;
        margin: 0 auto;
        height: 85px;
        margin-top: 24px;
        border-left: 3px solid #FA5151;
        padding-left: 16px;

        .num {
            overflow: hidden;

            .left {
                font-weight: 600;
                font-size: 48px;
                // line-height: 63px;
                text-transform: capitalize;
                color: #FB554E;
                float: left;
                vertical-align: middle;
            }

            .right {
                font-weight: 600;
                font-size: 17px;
                float: left;
                margin-left: 12px;
                line-height: 60px;
                text-transform: capitalize;
                color: #FB554E;
                vertical-align: middle;
            }
        }

        .explain {
            font-size: 16px;
            line-height: 22px;
            text-transform: capitalize;
            color: rgba(0, 0, 0, 0.54);
        }
    }

    .source {
        // width: 530px;
        margin: 0 auto;
        font-size: 14px;
        line-height: 20px;
        text-align: center;
        text-transform: capitalize;
        color: rgba(0, 0, 0, 0.32);
        margin-top: 88px;
    }

    .cooperation {
        width: 288px;
        height: 64px;
        background: #FB554E;
        border-radius: 4px;
        margin: 0 auto;
        text-align: center;
        line-height: 64px;
        margin-top: 24px;
        font-size: 20px;
        color: #fff;
        font-weight: 500;
        cursor: pointer;
    }
}

.footer {
    padding: 24px;
    background: #404040;

    .one {
        width: 88%;
        margin: 0 auto;
        text-align: center;
        font-size: 14px;
        line-height: 20px;
        color: #FFFFFF;
    }

    .two {
        font-size: 12px;
        line-height: 18px;
        text-align: center;
        justify-content: center;
        align-items: center;
        text-transform: capitalize;
        color: #FFFFFF;
        display: flex;
        margin-top: 16px;
    }
}

.DeclarationLetter {
    .DeclarationLetter_title {
        font-weight: 500;
        font-size: 22px;
        line-height: 30px;
        text-align: center;
        color: #000000;
    }

    .DeclarationLetter_contant {
        width: 80%;
        margin: 0 auto;
        font-size: 14px;
        line-height: 22px;
        color: #000000;
    }

    .DeclarationLetter_bottom {
        font-size: 14px;
        width: 80%;
        margin: 0 auto;
        line-height: 22px;
        color: #000000;
        text-align: right
    }

    .know {
        margin: 0 auto;
        width: 176px;
        height: 56px;
        background: #FED847;
        border-radius: 4px;
        text-align: center;
        line-height: 56px;
        font-size: 16px;
        margin-top: 48px;
        margin-bottom: 56px;
        color: #000000;
    }
}

.navigationButton {
    width: 72px;
    height: 312px;
    // background: tan;
    position: fixed;
    right: 56px;
    bottom: 56px;
    z-index: 999;

    .li:hover {
        background: #FED847;
        color: #000000;
    }

    .li {
        cursor: pointer;
        width: 100%;
        height: 72px;
        margin-bottom: 8px;
        border: 1px solid rgba(0, 0, 0, 0.12);
        background: #FFFFFF;
        box-sizing: border-box;
        border-radius: 4px;
        text-align: center;
        font-size: 12px;
        line-height: 20px;
        color: rgba(0, 0, 0, 0.54);
    }
}

.ScanCodeStyle {
    width: 372px;
    height: 206px;
    position: fixed;
    right: 130px;
    bottom: 196px;
    z-index: 999;
}

.information {
    // width: 348px;
    padding: 16px;
    background: #Fff;
    position: fixed;
    bottom: 138px;
    right: 144px;
    border-radius: 4px;
    z-index: 999;
    box-shadow: 0px 8px 16px rgba(12, 0, 51, 0.1);

    .li {
        margin: 9px 0;
        margin-left: 16px;
        overflow: hidden;

        .left {
            float: left;
            width: 30px;
        }

        .right {
            float: left;

            .title {
                font-size: 17px;
                line-height: 24px;
                text-transform: capitalize;
                color: #000000;
                font-weight: 500;
            }

            .name {
                width: 300px;
                line-height: 24px;
                font-size: 17px;
                color: rgba(0, 0, 0, 0.54);
            }
        }
    }
}

.cooperation {
    width: 750px;
    height: 732px;

    // background: tan;
    .cooperation_top {
        width: 100%;
        height: 106px;
        background: #FB554E;
        text-align: center;
        font-size: 32px;
        line-height: 106px;
        color: #FFFFFF;
        position: relative;

        .closeIcon {
            position: absolute;
            right: 40px;
            top: 29px;
            cursor: pointer;
        }
    }

    .title {
        font-size: 22px;
        line-height: 30px;
        color: #000000;
        text-align: center;
        margin-top: 56px;
    }

    .tips {
        font-size: 14px;
        line-height: 22px;
        color: rgba(0, 0, 0, 0.54);
        text-align: center;
        margin-top: 16px;
    }

    .el_form {
        // width:
        padding: 56px;
    }

    .submitBtn {
        width: 184px;
        height: 62px;
        background: #FB554E;
        font-size: 22px;
        line-height: 62px;
        color: #FFFFFF;
        text-align: center;
        margin: 0 auto;
        border-radius: 4px;
        cursor: pointer;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/indexPc.vue